import { ErrorHandler, Injectable, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ButtonsModule } from '@progress/kendo-angular-buttons'; // Example Kendo UI module
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { POPUP_CONTAINER, PopupModule } from '@progress/kendo-angular-popup';
import { Pmis3VesselVisitComponent } from '@pmis3/pmis3-vessel-visit';
import { VesselVisitWebcomponentComponent } from './vessel-visit-webcomponent.component';
import * as vesselActivityStore from '@pmis3/vessel-activity-core';
import { StoreModule } from '@ngrx/store';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ButtonsModule, // Import Kendo UI modules here
        RouterModule,
        ...KENDO_DIALOGS,
        LayoutModule,
        PopupModule,
        CommonModule,
        Pmis3VesselVisitComponent,  
        StoreModule.forRoot({}),
        // StoreModule.forFeature('vesselState', masterDataStore.vesselReducer),
        // StoreModule.forFeature('locationState', masterDataStore.locationReducer),
        // StoreModule.forFeature('organizationState', masterDataStore.organizationReducer),
        // StoreModule.forFeature('vesselScheduleState', vesselActivityStore.vesselScheduleReducer),
        // StoreModule.forFeature('vesselStopState', vesselActivityStore.vesselStopReducer),
        // StoreModule.forFeature('vesselMovementState', vesselActivityStore.vesselMovementReducer),
        StoreModule.forFeature('vesselVisitState', vesselActivityStore.vesselVisitReducer),
    ],
    declarations: [VesselVisitWebcomponentComponent],
    providers: [
        {
            provide: POPUP_CONTAINER,
            useValue: { nativeElement: document.body }
        }
    ],
    bootstrap: [],
})
export class VesselVisitWebcomponentModule {
    constructor(private injector: Injector) {
        const myElement = createCustomElement(VesselVisitWebcomponentComponent, {
            injector,
        });
        if (!customElements.get('noa-webcomponent'))
            customElements.define(
                'noa-webcomponent',
                myElement
            );
    }

    ngDoBootstrap() {
        console.log('test');
    }
}
